import { render, staticRenderFns } from "./ListaComercioExterior.vue?vue&type=template&id=16e03a2e&"
import script from "./ListaComercioExterior.vue?vue&type=script&lang=js&"
export * from "./ListaComercioExterior.vue?vue&type=script&lang=js&"
import style0 from "./ListaComercioExterior.vue?vue&type=style&index=0&id=16e03a2e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports